import apiClient from './api'

const marginalizationService = {
  async getMarginalizations(params = {}) {
    try {
      params['_no_pagination_'] = 1
      const response = await apiClient.get('/admin/marginalizations', { params })
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  async getMarginalization(id) {
    try {
      const response = await apiClient.get(`/admin/marginalizations/${id}`)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  async createMarginalization(marginalizationData) {
    try {
      const response = await apiClient.post('/admin/marginalizations', marginalizationData)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  async updateMarginalization(id, marginalizationData) {
    try {
      const response = await apiClient.put(`/admin/marginalizations/${id}`, marginalizationData)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  async deleteMarginalization(id) {
    try {
      const response = await apiClient.delete(`/admin/marginalizations/${id}`)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  }
}

export default marginalizationService 